import { useTexture } from '@react-three/drei'
import { useMemo } from 'react'
import * as THREE from 'three'
import { textureAsset } from '../../assetStore'

export type PowerUpTextures = {
    orbMatcap: THREE.Texture
    iconAtlas: THREE.Texture
}

export function usePowerUpMatcapTexture() {
    return useTexture(textureAsset.Orb_Matcap, (texture) => {
        texture.colorSpace = THREE.SRGBColorSpace
    })
}

export function usePowerUpIconAtlasTexture() {
    return useTexture(textureAsset.PowerUps_Atlas, (texture) => {
        texture.colorSpace = THREE.SRGBColorSpace
        texture.flipY = false
    })
}

export function usePowerUpTextures(): PowerUpTextures {
    const orbMatcap = usePowerUpMatcapTexture()
    const iconAtlas = usePowerUpIconAtlasTexture()
    return useMemo(
        () => ({ orbMatcap, iconAtlas }),
        [orbMatcap, iconAtlas],
    )
}

useTexture.preload(textureAsset.Orb_Matcap)
useTexture.preload(textureAsset.PowerUps_Atlas)
